// Vendor imports
const _ = require('lodash')
const { createSelector } = require('reselect')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Cousin imports
const collectionEditCoverImageModalSelectors = require('../collection-edit-cover-image-modal/selectors')
const collectionEditHeaderImageModalSelectors = require('../collection-edit-header-image-modal/selectors')

const containerState = state => state.collectionEditModal

const collection = createSelector(
  containerState,
  s => _.get(s, 'collection', null)
)

const isVisible = createSelector(
  [
    collection,
    collectionEditCoverImageModalSelectors.isVisible,
    collectionEditHeaderImageModalSelectors.isVisible
  ],
  (
    collection,
    isCoverImageModalVisible,
    isHeaderImageModalVisible
  ) => (
    !!collection &&
    !isCoverImageModalVisible &&
    !isHeaderImageModalVisible
  )
)

const isCollectionDeletePending = createSelector(
  containerState,
  s => _.get(s, 'collectionDeleteState') === FetchStateEnum.LOADING
)

const isCollectionUpdatePending = createSelector(
  containerState,
  s => _.get(s, 'collectionUpdateState') === FetchStateEnum.LOADING
)

const isHeaderImageUploadPending = createSelector(
  containerState,
  s => _.get(s, 'headerImageUploadState') === FetchStateEnum.LOADING
)

const isPending = createSelector(
  [
    isCollectionDeletePending,
    isCollectionUpdatePending,
    isHeaderImageUploadPending
  ],
  (...args) => args.some(Boolean)
)

const coverImage = createSelector(
  collection,
  c => _.get(c, 'cover_image_url', null)
)

const headerImage = createSelector(
  collection,
  c => _.get(c, 'header_image_urls.large', null)
)

module.exports = {
  // Flags
  isCollectionDeletePending,
  isCollectionUpdatePending,
  isHeaderImageUploadPending,
  isPending,
  isVisible,
  // Values
  collection,
  containerState,
  coverImage,
  headerImage
}
